import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Renders a private image by fetching it as a blob through authenticated API.
 */
export default function SecureImage({ path, alt = "", className = "", onClick }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let revoke = null;
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`/files/${path}`, { responseType: "blob" });
        if (cancelled) return;
        const url = URL.createObjectURL(res.data);
        revoke = url;
        setSrc(url);
      } catch {
        if (!cancelled) setErr(true);
      }
    })();
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);

  if (err) return <div className={`${className} grid place-items-center bg-zinc-900 text-zinc-600 text-xs`}>Failed</div>;
  if (!src) return <div className={`${className} animate-pulse bg-zinc-900`} />;
  return <img src={src} alt={alt} className={className} onClick={onClick} loading="lazy" data-testid="secure-image" />;
}
